import styled from 'styled-components';
import { Select } from 'antd';

export const SelectStyled = styled(Select)`
  width: 100%;
`;
